import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '30px',
    marginBottom: '0.75rem',
  },
  fareItem: {
    height: '100px',
    marginBottom: '0.5rem',
  },
  filters: {
    height: '50px',
    marginBottom: '0.75rem',
  },
  map: {
    height: '300px',
    marginBottom: '0.5rem',
  },
};

const SkeletonBusDirectoryMapMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, fareItem, map, filters } = styles;
  return (
    <Box
      className={`${className} ${SkeletonBusDirectoryMapMobile.componentName} fr-skeleton`}
      style={style}
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={map} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={fareItem} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="8">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonBusDirectoryMapMobile.componentName = 'SkeletonBusDirectoryMapMobile';

export default SkeletonBusDirectoryMapMobile;
